import '../../../../styles/oa.scss';
import React, { useState, useEffect, useRef, useContext } from 'react';
import { ListView,PullToRefresh,Card,WhiteSpace} from 'antd-mobile';
import SearchWrapper from '@/components/searchWrapper';
import Filter from '@/components/filter';
import { MyContext } from '@/utils/contextManager';
import { noticeList } from '../../../../services/saas/oa';
import { getUser } from '../../../../utils';
import sysConfig from '@/sysConfig';
import { useHistory } from 'react-router';
import func from '@/utils/Func';

const { preRouteUrl } = sysConfig;

function ListWrap(props) {
  return  <div>
            {props.children}
          </div>
}

function NoticeList(props) {
  const {isRead} = props;
  const pageSize = 10;
  let [pageIndex, setIndex] = useState(0);
  const [hasMore, setHasMore] = useState(true);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [draging, setDraging] = useState(false);
  const [keyValue, setKeyValue] = useState('');
  const [filter, setFilter] = useState({});
  const { setFilters } = useContext(MyContext);

  const {userId} = getUser();
  const history = useHistory();

  const dataS = new ListView.DataSource({
    getRowData: (dataBlob, sectionID, rowID) => {
      return dataBlob[sectionID][rowID];
    },
    rowHasChanged: (row1, row2) => row1 !== row2,
  });
  const [dataSource, setDataSouce] = useState(dataS);

  const getData = async function (page) {
    setLoading(true);
    const param = {
      current: page,
      size: pageSize,
      name: keyValue,
      userId,
      isRead
    };

    const respActive = await noticeList(param);
    if (respActive&&respActive.success && respActive.data) {
      let noticeList = [];
      if (page !== 1) {
        noticeList = [...data];
      }
      noticeList = [
        ...noticeList,
        ...respActive.data.records.map(item => ({
          receiveId:item.id,
          noticeId:item.notificationId,
          name: item.name,
          deptName: item.deptName,
          publishUserName: item.publishUserName,
          readNum: item.readNum,
          readTime:item.readTime,
          publishTime:item.publishTime,
        }))
      ];

      setLoading(false);
      setDraging(false);
      setData(noticeList);
      setDataSouce(dataSource.cloneWithRows(noticeList));
      setHasMore(respActive.data.current < respActive.data.pages);
      setIndex(page);
    }
  };

  const onEndReached = function () {
    if (!loading && hasMore) {
      getData(++pageIndex);
    }
  };

  useEffect(() => {
    getData(1);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filter, keyValue]);

  useEffect(() => {
    setFilters(
      <Filter
        data={[]}
        handleSearch={(item) => {
          setFilter(item);
        }}
      ></Filter>,
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const listRef = useRef();
  const row = (rowData, sectionID, rowID) => {
    const {receiveId,readNum,noticeId,name, publishTime,deptName} = rowData;
    return (
      <div>
        <WhiteSpace size="lg" />
        <Card full onClick={() => history.push(`${preRouteUrl}/oa/notice/detail/${readNum>0?'readed':receiveId}/${noticeId}`)}>
          <Card.Header
            title={deptName}
            extra={<span>{func.timeToDif('',publishTime)}</span>}
          />
          <Card.Body>
            <div>{name}</div>
          </Card.Body>
          <Card.Footer content='' extra={<div></div>} />
        </Card>
      </div>
    );
  };
  return (
    <ListView
        ref={listRef}
        dataSource={dataSource}
        initialListSize={pageSize}
        renderHeader={() => <SearchWrapper hideSelector={true} onChange={setKeyValue} />}
        renderFooter={() => (
          <div style={{ padding: 30, textAlign: 'center' }}>
            {hasMore ? (loading ? '加载中...' : '加载完成') : '没有更多'}
          </div>
        )}
        renderBodyComponent={() => <ListWrap />}
        renderRow={row}
        className="active-list-wrap"
        pageSize={pageSize}
        onScroll={() => {
          console.log('scroll');
        }}
        scrollRenderAheadDistance={500}
        onEndReached={onEndReached}
        onEndReachedThreshold={10}
        pullToRefresh={
          <PullToRefresh
            refreshing={draging}
            onRefresh={() => {
              setDraging();
              getData(1);
            }
          }
        />
        }
    />
  );
}

export default NoticeList;

